import { Flex, Text } from '@chakra-ui/react'

type Props = {
  mt?: string
}

const Footer: React.FC<Props> = ({ mt }) => {
  const currentYear = new Date(Date.now()).getFullYear()
  return (
    <Flex
      data-cy='footer'
      minHeight='56px'
      backgroundColor='primaryColors.400'
      color='white'
      fontWeight='700'
      alignItems='center'
      justifyContent='center'
      mt={mt}
    >
      <Text>© Education Journey - {currentYear}</Text>
    </Flex>
  )
}

export default Footer
